import { useSelector } from "react-redux";
import { RootState } from "store";

import { STATIC_STRINGS } from "@asez/shared";

import PreviewCard from "../components/PreviewCard";

const RenderData = () => {
  const { title, jobDesignation, experience, skills } = useSelector(
    (state: RootState) => state.stepOne
  );

  const {
    scheduleSetting,
    timing,
    proctoring,
    selectedQuestions,
    customQuestions,
  } = useSelector((state: RootState) => state.stepFour);

  return (
    <div className="flex justify-center text-sm xl:text-base">
      <div
        className="grid max-w-full"
        style={{
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        }}
      >
        <PreviewCard title={STATIC_STRINGS.BASIC_INFORMATION} stepNumber="1">
          <div className="mb-2 pb-2 border-b border-neutral-dark/60">
            <div className="font-medium mb-1">
              {STATIC_STRINGS.TITLE_FOR_ASSESSMENT}
            </div>
            <div>{title}</div>
          </div>
          <div className="mb-2 pb-2 border-b border-neutral-dark/60">
            <div className="font-medium mb-1">
              {STATIC_STRINGS.JOB_DESIGNATION}
            </div>
            <div>{jobDesignation}</div>
          </div>
          <div className="mb-2">
            <div className="font-medium mb-1">
              {STATIC_STRINGS.EXPERIENCE_RANGE}
            </div>
            <div>{` ${experience[0]} - ${experience[1]} years`}</div>
          </div>
        </PreviewCard>
        <PreviewCard title={STATIC_STRINGS.SKILLS} stepNumber="1">
          {skills.length > 0 ? (
            <div className="flex flex-wrap">
              {skills.map((skill: string, index: number) => (
                <div key={index} className="bg-body-gray rounded-lg p-2 m-1">
                  {skill}
                </div>
              ))}
            </div>
          ) : (
            <div className="flex h-full w-full justify-center items-center">
              {STATIC_STRINGS.NO_SKILLS_SELECTED}
            </div>
          )}
        </PreviewCard>
        <PreviewCard title={STATIC_STRINGS.TIMING_PROCTORING} stepNumber="4">
          <div className="mb-2 pb-2 border-b border-neutral-dark/60">
            <div className="font-medium mb-1">
              {STATIC_STRINGS.SCHEDULE_TIMINGS}
            </div>
            <div>
              {scheduleSetting === STATIC_STRINGS.TIME_PERIOD ? (
                <>
                  From: {new Date(timing.startTime).toLocaleString()} <br />
                  To: {new Date(timing.endTime).toLocaleString()}
                </>
              ) : (
                `${timing.duration} ${
                  timing.duration === 1 ? timing.unit.slice(0, -1) : timing.unit
                }`
              )}
            </div>
          </div>
          <div className="mb-2">
            <div className="font-medium mb-1">
              {STATIC_STRINGS.PROCTORING_ENABLED}
            </div>
            <div>{proctoring ? STATIC_STRINGS.YES : STATIC_STRINGS.NO}</div>
          </div>
        </PreviewCard>
        <PreviewCard title={STATIC_STRINGS.EXTRA_QUESTIONS} stepNumber="4">
          {(() => {
            const filteredQuestions = [
              ...selectedQuestions,
              ...customQuestions,
            ].filter((question) => question.include);
            return filteredQuestions.length > 0 ? (
              <div className="flex flex-wrap">
                {filteredQuestions.map((question, index) => (
                  <div key={index} className="bg-body-gray rounded-lg p-2 m-1">
                    {question.name}
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex h-full w-full justify-center items-center">
                {STATIC_STRINGS.NO_QUESTIONS_SELECTED}
              </div>
            );
          })()}
        </PreviewCard>
      </div>
    </div>
  );
};

export default RenderData;
